import { useState } from "react";
import Page from "../../Page";
import EventsCalendar from "../../Calendar/EventsCalendar";

const LiveEventsMarketingCalendar = (props) => {
  
  const [selectedSessionFromHome, setSelectedSessionFromHome] = useState({});
  const [selectedSessionPos, setSelectedSessionPos] = useState(0)
return(<>
  <Page>
  <EventsCalendar 
        isHome={false} isLearn={true}
        isLive={true}
        marketingDateRange={null}
        setSelectedSessionFromHome={setSelectedSessionFromHome}
        selectedSessionPos={selectedSessionPos}
        setSelectedSessionPos={setSelectedSessionPos}
        isEvents={true} />
  </Page>
  </>)
  };

export default LiveEventsMarketingCalendar;
